var _metadata, _defs, _desc, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 27,
    viewBox: "0 0 36 27",
    id: "svg24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata30"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs28"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, "svg/backtoMap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc4"
  }, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 1
    },
    transform: "translate(1,3)",
    id: "SHADOW"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeLinejoin: "round"
    },
    id: "Path-2",
    d: "m 31.444824,6.0908203 c 0,0 -17.290527,0.7832031 -18.954101,0.7832031 0,-0.7832031 0,-2.5874023 0,-6.8740234 C 6.852529,3.59375 1.5424805,9.1647949 0,11.520752 c 1.3815104,2.319499 5.5450846,6.159749 12.490723,11.520752 0,-4.19633 0,-6.710165 0,-7.541504 2.154459,-0.333333 8.472493,0.08234 18.954101,1.247009 0,-7.1041257 0,-10.6561887 0,-10.6561887 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "Path-2-Copy",
    d: "m 13.199097,23.041504 c 0,-3.781209 0,-6.087484 0,-6.918823 0.216381,-0.03348 1.510169,0.01837 1.810547,0 1.793608,-0.109677 7.605335,0.431766 17.43518,1.624328 L 32.726562,7.4057617 31.444824,6.0908203"
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Path",
    y2: 17.422729,
    x2: 31.832031,
    y1: 7.1119385,
    x1: 32.089478
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      strokeWidth: 2
    },
    id: "Path-3",
    y2: 23.514282,
    x2: 13.438904,
    y1: 16.015198,
    x1: 13.199097
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 1
    },
    transform: "translate(1,1)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fab739",
      strokeLinejoin: "round"
    },
    id: "path13",
    d: "m 31.444824,6.0908203 c 0,0 -17.290527,0.7832031 -18.954101,0.7832031 0,-0.7832031 0,-2.5874023 0,-6.8740234 C 6.852529,3.59375 1.5424805,9.1647949 0,11.520752 c 1.3815104,2.319499 5.5450846,6.159749 12.490723,11.520752 0,-4.19633 0,-6.710165 0,-7.541504 2.154459,-0.333333 8.472493,0.08234 18.954101,1.247009 0,-7.1041257 0,-10.6561887 0,-10.6561887 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path15",
    d: "m 13.199097,23.041504 c 0,-3.781209 0,-6.087484 0,-6.918823 0.216381,-0.03348 1.510169,0.01837 1.810547,0 1.793608,-0.109677 7.605335,0.431766 17.43518,1.624328 L 32.726562,7.4057617 31.444824,6.0908203"
  }), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "line17",
    y2: 17.422729,
    x2: 31.832031,
    y1: 7.1119385,
    x1: 32.089478
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      strokeWidth: 2
    },
    id: "line19",
    y2: 23.514282,
    x2: 13.438904,
    y1: 16.015198,
    x1: 13.199097
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.4486a41d27246ce86e4a33d76d59f084.svg";
export { ForwardRef as ReactComponent };